// userSelectors.js

export const selectLoading = (state) => state.timeSlot.loading;
export const selectTimeSlotData = (state) => state.timeSlot.timeSlotData;
export const selectUpdatedScheduleData = (state) => state.timeSlot.updatedSheduleData;

